import { Button, FormControl, FormField, FormItem, FormLabel, Input } from '@kalos/ui';

import { useUserSearchFormContext } from './utils';

/**
 * The search fields. `inSheet` renders them for the phone filter sheet: one column, no form of
 * their own (the sheet is the form) and no Reset (the sheet has Reset filters).
 */
const CustomerSearchForm = ({ inSheet = false }: { inSheet?: boolean }) => {
  const form = useUserSearchFormContext();
  const Fields = inSheet ? 'div' : 'form';
  return (
    // intentionally ignored as values are used as they are typed in
    <Fields
      className={
        inSheet
          ? 'flex flex-col gap-4'
          : 'grid grid-cols-2 place-content-center gap-x-4 gap-y-3 md:grid-cols-3 lg:grid-cols-[repeat(5,minmax(0,1fr))_5rem]'
      }
      {...(inSheet ? {} : { onSubmit: form.handleSubmit(console.log) })}
    >
      <FormField
        control={form.control}
        name="firstname"
        render={({ field }) => (
          <FormItem>
            <FormLabel>First Name</FormLabel>
            <FormControl>
              <Input {...field} />
            </FormControl>
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="lastname"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Last Name</FormLabel>
            <FormControl>
              <Input {...field} />
            </FormControl>
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="businessname"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Business Name</FormLabel>
            <FormControl>
              <Input {...field} />
            </FormControl>
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="phone"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Phone Number</FormLabel>
            <FormControl>
              <Input {...field} />
            </FormControl>
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="email"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Email</FormLabel>
            <FormControl>
              <Input {...field} />
            </FormControl>
          </FormItem>
        )}
      />
      {!inSheet && (
        <Button
          type="reset"
          variant="outline"
          className="mt-auto max-w-max"
          onClick={() => form.reset()}
        >
          Reset
        </Button>
      )}
    </Fields>
  );
};

export default CustomerSearchForm;
